import { useId } from "react";

interface PlusCircleProps {
  width?: string | number;
  height?: string | number;
  className?: string;
  stroke?: string;
  strokeWidth?: string | number;
}

export const PlusCircle = (props: PlusCircleProps) => {
  const clipPathId = useId().replace(/:/g, "");
  const width = props.width ?? 20;
  const height = props.height ?? 20;
  const stroke = props.stroke ?? "#0056D6";
  const strokeWidth = props.strokeWidth ?? 1.66667;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      className={props.className}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M10.0007 13.332L10.0007 6.66536M13.334 9.9987L6.66732 9.9987M1.66732 9.9987C1.66732 5.39632 5.39828 1.66536 10.0007 1.66536C14.603 1.66536 18.334 5.39632 18.334 9.9987C18.334 14.6011 14.603 18.332 10.0007 18.332C5.39828 18.332 1.66732 14.6011 1.66732 9.9987Z"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(-1 0 0 -1 20 20)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
